// extracted by mini-css-extract-plugin
export default {"buttonReset":"---------packages-corgi-x-src-components-ButtonBase-ButtonBase-module__buttonReset"};